import { useNavigate, useLocation } from 'react-router-dom';
import { getDomainById } from '@/domain-registry';
import { useDomainStore } from '@/shared/stores/domainStore';

/**
 * Simple domain switching using navigation
 * Logs to domain store for analytics (routing handled by URL/React Router)
 */
export function useDomainSwitcher() {
  const navigate = useNavigate();
  const location = useLocation();
  const { logDomainVisit, saveLastVisitedRoute } = useDomainStore();
  
  const switchToDomain = (domainId: string, preservePath = false) => {
    const domain = getDomainById(domainId);
    if (!domain) {
      console.warn(`[useDomainSwitcher] Invalid domain: ${domainId}`);
      return;
    }
    
    // Log domain visit for analytics
    logDomainVisit(domainId, 'switcher');
    
    if (preservePath) {
      // Try to preserve the current path structure
      const currentPath = location.pathname.split('/').slice(2).join('/');
      const newPath = `/${domainId}/${currentPath || ''}`;
      
      // Save the route for this domain
      saveLastVisitedRoute(domainId, newPath);
      
      navigate(newPath, { replace: true });
    } else {
      // Navigate to the domain's default route
      const targetRoute = domain.defaultRoute;
      
      // Save the route for this domain
      saveLastVisitedRoute(domainId, targetRoute);
      
      navigate(targetRoute, { replace: true });
    }
  };
  
  return { switchToDomain };
}